import { FilterIds } from '../typings';

interface DisplayLabelMap {
  [key: string]: string;
}

export const COMPATIBLE_SIM_DISPLAY_LABEL_MAP: DisplayLabelMap = {
  'dual sim (pSIM + eSIM)': 'eSIM',
  'single sim (eSIM)': 'eSIM',
  'dual sim (pSIM + pSIM)': 'Dual SIM (Physical)',
  'dual sim (eSIM + eSIM)': 'Dual eSIM',
};

export const NETWORK_CAPABILITY_LABEL_MAP: DisplayLabelMap = {
  '5G': '3G, 4G, 5G',
  '4G': '3G, 4G',
};

export const filterDisplayLabelMap: {
  [key: string]: DisplayLabelMap;
} = {
  [FilterIds.CompatibleSim]: COMPATIBLE_SIM_DISPLAY_LABEL_MAP,
  [FilterIds.NetworkCapability]: NETWORK_CAPABILITY_LABEL_MAP,
};
